import {
	CreateDrawerFormProps,
	I18nFormDrawer,
	I18nFormFetchDrawer,
	UpdateDrawerFormProps,
	useDynamicConfig,
} from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { OrganizerFormValues, OrganizerType } from "../../../shared/types/organizer";
import { OrganizerFormDrawerContent, useValidateOrganizer } from "../../../shared/ui/OrganizerFormDrawerContent";
import { organizerService } from "../shared/api/organizerService";

export const OrganizerCreateDrawer: FC<CreateDrawerFormProps<OrganizerFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidateOrganizer();
	const { languageSettings } = useDynamicConfig();

	const initialValues: OrganizerFormValues = useMemo(
		() => ({
			name: "",
			type: OrganizerType.COMPANY,
			translations: [
				{ locale: languageSettings.fallback, description: [{ type: "paragraph", children: [{ text: "" }] }] },
			],
		}),
		[languageSettings.fallback],
	);

	return (
		<I18nFormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create organizer")}
			validate={validate}
			renderForm={(formProps) => <OrganizerFormDrawerContent {...formProps} {...props} />}
		/>
	);
};

export const OrganizerUpdateDrawer: FC<UpdateDrawerFormProps<OrganizerFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidateOrganizer();

	return (
		<I18nFormFetchDrawer
			{...props}
			title={t("Edit organizer")}
			queryFn={() => organizerService.show(props.id).then((x) => x.data.data)}
			queryKey={organizerService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => <OrganizerFormDrawerContent {...props} {...formProps} />}
		/>
	);
};
